import { create } from "zustand";

type NewChatPanelState = {
  opened: boolean;
  /** Número que o painel deve trazer preenchido, quando veio de um cartão de contato. */
  prefillPhone: string | null;
  open: (prefillPhone?: string | null) => void;
  toggle: () => void;
  close: () => void;
};

/**
 * Abertura da tela "Nova conversa" (SA-1304). Virou store porque agora ela é
 * aberta também de dentro da conversa, pelo cartão de contato compartilhado —
 * longe demais do estado local da página.
 *
 * `close` NÃO limpa o número: o painel sai com animação e trocar o conteúdo no
 * mesmo tick faz o campo piscar de volta para "+55" enquanto ele ainda está na
 * tela. Quem define o conteúdo é sempre a abertura.
 */
export const useNewChatPanel = create<NewChatPanelState>((set) => ({
  opened: false,
  prefillPhone: null,
  open: (prefillPhone = null) => set({ opened: true, prefillPhone }),
  toggle: () =>
    set((state) =>
      state.opened ? { opened: false } : { opened: true, prefillPhone: null }
    ),
  close: () => set({ opened: false }),
}));
